import React from "react";
import { View } from "react-native";
import { TouchableOpacity, StyleSheet } from "react-native";
import Colors from "../constants/AppColors";

const RadioButton = (props) => {
    return (<TouchableOpacity style={styles.circle}
        onPress={props.onPress}>
        {props.checked ? <View style={styles.checkedCircle} /> : <View />}
    </TouchableOpacity>)
}

export default RadioButton;

const styles = StyleSheet.create({

    circle: {
        width: 20,
        height: 20,
        padding: 4,
        borderWidth: 2,
        borderRadius: 10,
        marginHorizontal: 10,
        alignItems: "center", // To center the checked circle…
        justifyContent: 'center',
        borderColor: Colors.grey.border,
    },

    checkedCircle: {
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: Colors.primary
    }

});